import { useEffect } from "react";
/**
 * A custom React hook that behaves similarly to `useEffect` but allows for async
 * operations and provides an `AbortController` to cancel these operations.
 */ function useAsyncEffect(effect, deps) {
    useEffect(()=>{
        const abortController = new AbortController();
        const disposeFns = [
            ()=>abortController.abort()
        ];
        const runEffect = async ()=>{
            try {
                const dispose = await effect({
                    abortController,
                    aborted: ()=>abortController.signal.aborted
                });
                if (typeof dispose === "function") {
                    disposeFns.push(dispose);
                }
            } catch (error) {
                if (error.name !== "AbortError") {
                    // Handle or re-throw errors that are not abort errors
                    throw error;
                }
            }
        };
        runEffect();
        return ()=>disposeFns.forEach((d)=>d());
    }, deps);
}
export { useAsyncEffect };
